import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { configGetSettings } from 'common/helper/config/get-settings';
import { BuildingReviewButtonViewStore } from 'common/module/building-review/button/view-store';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { BuildingReviewFormViewFactory } from 'desktop/module/building-review/form/view.factory';
import { BuildingReviewFormViewService } from 'desktop/service/building-review-form-view/service';

export function BuildingReviewButtonViewStoreFactory(formFactory: boolean = false): BuildingReviewButtonViewStore {
  return new BuildingReviewButtonViewStore(
    EventEmitterFactory(),
    formFactory ? BuildingReviewFormViewFactory() : BuildingReviewFormViewService(),
    StatsGtmProviderService(),
    configGetSettings(),
    WindowLocationService()
  );
}
